<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.v-application {
  font-family: "Poppins", "Segoe UI", system-ui, -apple-system, sans-serif;
  color: #0f172a;
  background-color: var(--bg-primary);
}

/* Sistema Tipográfico ERP - Densidad de datos */
.erp-text-xs { font-size: 11px; line-height: 1.4; }
.erp-text-sm { font-size: 12px; line-height: 1.45; }
.erp-text-base { font-size: 13px; line-height: 1.5; }
.erp-text-lg { font-size: 14px; line-height: 1.5; }
.erp-text-xl { font-size: 16px; line-height: 1.4; }

/* Fuentes monoespaciadas para códigos SKU, IDs, códigos de barras */
.erp-mono {
  font-family: "JetBrains Mono", "SF Mono", "Consolas", monospace;
  font-feature-settings: "tnum" 1; /* Tabular numbers - alinea números verticalmente */
  font-size: 12px;
  letter-spacing: 0;
}

.erp-mono-sm {
  font-family: "JetBrains Mono", "SF Mono", "Consolas", monospace;
  font-feature-settings: "tnum" 1;
  font-size: 11px;
  letter-spacing: 0;
}

/* Headers de tablas - jerarquía estricta */
.erp-header {
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #475569;
}

/* Datos de tabla compactos */
.erp-data {
  font-size: 12px;
  line-height: 1.4;
  color: #1e293b;
}

/* Tracking para títulos de KPI */
.erp-kpi-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
}

.erp-kpi-value {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0f172a;
}

* {
  box-sizing: border-box;
}
</style>
